import { extendTheme } from "@chakra-ui/react";

export const theme = extendTheme({
  fonts: {
    mono: "'SF Mono','Fira Code','Fira Mono','Roboto Mono',monospace",
    nunito: "'Nunito', sans-serif",
    roboto: "'Roboto', sans-serif",
  },
});